import { reactive } from 'vue'

const dirtyForms = reactive(new Set())

export const markFormDirty = (formKey, isDirty) => {
  if (isDirty) {
    dirtyForms.add(formKey)
  } else {
    dirtyForms.delete(formKey)
  }
}

export const isAnyFormDirty = () => dirtyForms.size > 0

export const clearAllDirty = () => {
  dirtyForms.clear()
}

export const dirtyFormKeys = () => Array.from(dirtyForms)
